// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kH9M","col":"styles_col__3ABWc"};